import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-[#1A3A52]">
        <div className="max-w-4xl mx-auto text-center">
          <nav className="text-sm text-white/60 mb-4">
            <span>Home</span> <span className="mx-2">/</span> <span className="text-white">Privacy Policy</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            Privacy Policy
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto space-y-8">
          <p className="text-sm text-gray-500">Last Updated: January 2025</p>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Introduction</h2>
            <p className="text-gray-700 leading-relaxed">
              Nakhalat Finance (Private) Limited ("we," "our," or "us") is committed to protecting your privacy and personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Information We Collect</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Personal identification information (name, address, phone number, email)</li>
              <li>Financial information (employment details, income, banking information)</li>
              <li>Identification documents (national ID, proof of residence)</li>
              <li>Credit history and references</li>
              <li>Information provided through forms, applications, and communications</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">How We Use Your Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Process and evaluate loan applications</li>
              <li>Verify your identity and conduct credit assessments</li>
              <li>Communicate with you about your application and account</li>
              <li>Comply with legal and regulatory requirements</li>
              <li>Prevent fraud and maintain security</li>
              <li>Improve our services and customer experience</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Information Sharing and Disclosure</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We may share your information with:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Credit reference bureaus for credit assessment purposes</li>
              <li>Regulatory authorities as required by law</li>
              <li>Service providers who assist in our operations (under strict confidentiality agreements)</li>
              <li>Legal and professional advisors when necessary</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              We do not sell, rent, or trade your personal information to third parties for marketing purposes.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Data Security</h2>
            <p className="text-gray-700 leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Your Rights</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Access your personal information we hold</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information (subject to legal obligations)</li>
              <li>Object to processing of your information</li>
              <li>Withdraw consent where processing is based on consent</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Data Retention</h2>
            <p className="text-gray-700 leading-relaxed">
              We retain your personal information for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-[#1A3A52] mb-4">Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you have questions about this Privacy Policy or wish to exercise your rights, please contact us:
            </p>
            <div className="bg-[#E8EFF5] rounded-lg p-6 space-y-2">
              <p className="text-gray-700"><strong>Email:</strong> <a href="mailto:apply@nakhalatfinance.com" className="hover:text-[#1A3A52] transition-colors cursor-pointer">apply@nakhalatfinance.com</a></p>
              <p className="text-gray-700"><strong>Phone:</strong> <a href="tel:+263782251180" className="hover:text-[#1A3A52] transition-colors cursor-pointer">+263 78 225 1180</a></p>
              <p className="text-gray-700"><strong>Address:</strong> 56 Edmonds Ave, Belvedere, Harare, Zimbabwe</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}